import { createFileRoute } from "@tanstack/react-router";
import Verification from "@/pages/admin/Verification";

export const Route = createFileRoute("/admin/verification")({
  component: Verification,
});
